<template>
  <div style="height: 100vh; background: #fffaf7" @click="down">
    <a href="https://apps.apple.com/cn/app/小筑教育/id1583545858" style="height: 100vh;width:100vw;background:red"></a>
    <img :src="imgSrc" />
    <van-overlay :show="show" @click="show = false">
      <div class="wrapper" @click.stop style="z-index: 99999999999999">
        <!-- <div class="block" /> -->
        <van-image :src="openRow" class="Invite f-l-r m-r-075"></van-image>
      </div>
    </van-overlay>
  </div>
</template>

<script>
import { getAppClient } from "@/utils/commonUtils";
export default {
  data() {
    return {
      imgArr: {
        ids: [84],
      },
      imgSrc: "",
      show: false,
      openRow: require("@/assets/imgs/weChat/openRow.png"),

    };
  },
  created() {
    this.getBgUrl();
  },
  methods: {
    down() {
      if (getAppClient() == "JSAPI") {
        this.show = true;
        return false
      }
      // 下载app
      let data = {
        type: 1,
      };
      if (!this.AndroisIos()) data.type = 2;
      this.Api({
        url: "api/getVersionNum",
        method: "POST",
        data,
      }).then((res) => {
        if (res.retuCode == 5000) {
          if (!this.isNotNull(res.data.pkgUrl)) {
            let text = "安卓系统暂未开通app,很快就会上线";
            if (data.type == 2) text = "ios系统暂缓开通app,很快就会上线~";
            alert(text);
            return false;
          }
          if (data.type == 2) {
            window.location.href = res.data.pkgUrl
          } else {
            window.open(res.data.pkgUrl)
          }
          // window.location.href('itms-apps://itunes.apple.com/app/小筑教育/id1583545858');
        }
      });
    },
    getBgUrl() {
      // 获取下载app背景图
      let data = this.imgArr;
      this.Api({
        url: "api/getpactureById",
        method: "POST",
        data,
      }).then((res) => {
        if (res.retuCode == 5000) {
          this.imgSrc = res.data[0].url;
        }
      });
    },
  },
};
</script>

<style scoped>
.Invite {
  width: 50%;
}
</style>